import React from 'react';
import { childrenServices } from '../../services/children.service';
import { SubscriptionServices } from '../../services/subscription.service';
//import{deviceServices} from "../../services/device.service";
import DataGrid, { Column, Editing, Paging, RequiredRule, Form, Position, Label } from 'devextreme-react/data-grid';
import { Item } from 'devextreme-react/form';
import notify from 'devextreme/ui/notify';
import { Popup } from 'devextreme-react/popup';
import { Elements, CardElement, ElementsConsumer } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { config } from '../../helpers/config';
import './Subscription/CardSectionStyles.css';

// Make sure to call 'loadStripe' outside of a component's render to avoid
// recreating the 'Stripe' object on every render.
const stripePromise = loadStripe('pk_test_BTfnq8JcKptMGdZ90CKDrUw4008fwAVEYM');

class ChildrenElements extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      childRows: [],
      userId: localStorage.getItem('userId'),
      rows: [],
      deviceType: [
        {
          id: 1,
          name: 'Camera',
        },
        {
          id: 2,
          name: 'Narrative',
        },
      ],
      allowAddDevice: false,
      allowAddChild: false,
      addPayment: false
    };

    //child
    this.onChildRowInserting = this.insertChild.bind(this);
    this.onChildRowUpdating = this.updateChild.bind(this);
    this.onChildRowRemoving = this.removeChild.bind(this);
    this.onInitNewRow = this.showPayment.bind(this);
    this.onEditingStart = this.hidePayment.bind(this);
    this.dateColumn_customizeText = this.dateColumn_customizeText.bind(this);
    this.refreshChildData();

    //device
    // this.onRowInserting = this.insert.bind(this);
    // this.onRowUpdating = this.update.bind(this);
    // this.onRowRemoving = this.remove.bind(this);
    // this.refreshData();
  }

  //begin child grid
  refreshChildData() {
    childrenServices.getByUserId(this.state.userId).then(
      (data) => {
        this.setState({ childRows: data });
        if (data.length >= config.numberOfChildAllowToAdd) {
          this.setState({ allowAddChild: false });
        } else {
          this.setState({ allowAddChild: true });
        }
      },
      (error) => {
        notify({
          position: 'top right',
          message: 'Failed: ' + error,
          type: 'error',
          maxWidth: 200,
          closeOnOutsideClick: false,
          closeOnClick: true,
          displayTime: 6000,
        });
      }
    );
  }
  
  insertChild(event) {
    let { rows } = this.state;
    var isDuplicate = false;
    var email= localStorage.getItem('email');
    if(email==='')
    {
      notify({
        position: 'top right',
        message: "Failed: Email is missing. Please add your email addres.",
        type: 'error',
        maxWidth: 200,
        closeOnOutsideClick: false,
        closeOnClick: true,
        displayTime: 6000,
      });
      this.refreshChildData();
    }
    else{
      rows.forEach((row) => {
        if (row.childrenId === event.data.childrenId) {
          isDuplicate = true;
        }
      });
      if (isDuplicate) {
        notify({
          position: 'top right',
          message: "Failed: Children ID '" + event.data.childrenId + "' is already exist.",
          type: 'error',
          maxWidth: 200,
          closeOnOutsideClick: false,
          closeOnClick: true,
          displayTime: 6000,
        });
        this.refreshChildData();
      } else {
        //Save child
        var childData = event.data;
        childData.ParentId = this.state.userId;
        childrenServices.register(childData).then(
          (childResponse) => {
            if (childResponse) {
              notify({ position: 'top right', message: 'Added successfully', type: 'success', maxWidth: 200 });
              this.refreshChildData();
              
              //Subscription
              const stripe = this.props.stripe;
              const elements = this.props.elements;
              stripe
                .createPaymentMethod({
                  type: 'card',
                  card: elements.getElement(CardElement),
                  billing_details: {
                    email: email,
                  },
                })
                .then(function (resultPayment) {
                  if (resultPayment.error) {
                    // Show error in payment form
                    notify({
                      position: 'top right',
                      message: 'Failed: ' + resultPayment.error,
                      type: 'error',
                      maxWidth: 200,
                      closeOnOutsideClick: false,
                      closeOnClick: true,
                      displayTime: 6000,
                    });
                  } else {
                    // Otherwise send paymentMethod.id to your server
                    SubscriptionServices.createCustomer(resultPayment.paymentMethod.id, email).then(function (result) {
                      notify({
                        position: 'top right',
                        message: 'Child has been subscribed successfully',
                        type: 'success',
                        maxWidth: 200,
                      });
                  
                      //call api to update trial date and subscription
                      childResponse.startTrialDate = new Date(result.trial_start * 1000);
                      childResponse.endTrialDate = new Date(result.trial_end * 1000);
                      childResponse.startSubscribedDate = new Date(result.current_period_start * 1000);
                      childResponse.endSubscribedDate = new Date(result.current_period_end * 1000);
                      childResponse.isSubscribed = true;
                      childrenServices.update(childResponse).then(
                        response=>{
                          notify({position:'top right', message:'Updated subscription status successfully',type:'success',maxWidth:200});
                          window.location.reload(true); //reload
                        }, 
                        error=>{
                          notify({position:'top right', message:"Failed: "+ error, type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
                        }
                      );
                    });
                  }
                });
            }
          },
          (error) => {
            notify({
              position: 'top right',
              message: 'Failed: ' + error,
              type: 'error',
              maxWidth: 200,
              closeOnOutsideClick: false,
              closeOnClick: true,
              displayTime: 6000,
            });
            this.refreshChildData();
          }
        );
      }
    }
  }

  updateChild(event) {
    let { childRows } = this.state;
    var newData = event.newData;
    childRows = childRows.map((row) => (row.childrenId === event.key ? { ...row, ...newData } : row));
    var changedRow;
    childRows.forEach((row) => {
      if (event.key === row.childrenId) changedRow = row;
    });
    if (changedRow) {
      childrenServices.update(changedRow).then(
        (response) => {
          notify({ position: 'top right', message: 'Updated successfully', type: 'success', maxWidth: 200 });
          this.refreshChildData();
        },
        (error) => {
          notify({
            position: 'top right',
            message: 'Failed: ' + error,
            type: 'error',
            maxWidth: 200,
            closeOnOutsideClick: false,
            closeOnClick: true,
            displayTime: 6000,
          });
          this.refreshChildData();
        }
      );
    }
  }

  removeChild(event) {
    childrenServices.delete(event.key).then(
      (response) => {
        if (response) {
          notify({ position: 'top right', message: 'Deleted successfully', type: 'success', maxWidth: 200 });
          this.refreshChildData();
        }
      },
      (error) => {
        notify({
          position: 'top right',
          message: 'Failed: ' + error,
          type: 'error',
          maxWidth: 200,
          closeOnOutsideClick: false,
          closeOnClick: true,
          displayTime: 6000,
        });
        this.refreshChildData();
      }
    );
  }
  //end child grid

  showPayment(event){
    this.setState({ addPayment: true });
  }

  hidePayment(event){
    this.setState({ addPayment: false });
  }

  dateColumn_customizeText(cellInfo) {
    var text = cellInfo.valueText == '1/1/1901' || cellInfo.valueText == '1/1/1970' ? '' : cellInfo.valueText;
    return (cellInfo.value = text);
  }

  statusEditorRender = (options) => {
    return <CardElement options={options} />;
  };

  render() {
    const { childRows, allowAddChild, deviceType, allowAddDevice, rows, addPayment } = this.state;
    const options = {
      style: {
        base: {
          color: '#32325d',
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: 'antialiased',
          fontSize: '16px',
          '::placeholder': {
            color: '#aab7c4',
          },
        },
        invalid: {
          color: '#fa755a',
          iconColor: '#fa755a',
        },
      },
    };
    return (
      <div>
        <h4>Children Management</h4>
        <React.Fragment>
          <DataGrid
            id={'gridContainer'}
            dataSource={childRows}
            keyExpr={'childrenId'}
            allowColumnReordering={true}
            showBorders={true}
            showRowLines={true}
            onRowInserting={this.onChildRowInserting}
            onRowUpdating={this.onChildRowUpdating}
            onRowRemoving={this.onChildRowRemoving}
            onInitNewRow={this.onInitNewRow}
            onEditingStart={this.onEditingStart}>
            <Paging enabled={true} />
            <Editing mode="popup" allowUpdating={true} allowDeleting={true} allowAdding={allowAddChild}>
              <Popup title="Children" showTitle={true} width={200} height={525}>
                <Position my="top" at="top" of={window} />
              </Popup>
              <Form>
                <Item itemType="group" colCount={2} colSpan={2} caption="Information">
                  <Item dataField="firstName" />
                  <Item dataField="lastName" />
                  <Item dataField="dob" />
                </Item>
                <Item itemType="group" caption="Payment" visible={addPayment}>
                  {/* <Item dataField="email"/> */}
                  <Item dataField="Status" editorOptions={{ height: 100 }}>
                    <Label visible={false}></Label>
                  </Item>
                </Item>
              </Form>
            </Editing>

            <Column dataField={'firstName'} caption={'First Name'}>
              <RequiredRule />
            </Column>
            <Column dataField={'lastName'} caption={'Last Name'}>
              <RequiredRule />
            </Column>
            <Column dataField={'dob'} caption={'Date of birth'} dataType="date">
              <RequiredRule />
            </Column>
            <Column
              dataField={'startTrialDate'}
              caption={'Start Trial'}
              dataType="date"
              allowEditing={false}
              customizeText={this.dateColumn_customizeText}
            />
            <Column
              dataField={'endTrialDate'}
              caption={'End Trial'}
              dataType="date"
              allowEditing={false}
              customizeText={this.dateColumn_customizeText}
            />
            <Column
              dataField={'startSubscribedDate'}
              caption={'Start Subscribed'}
              dataType="date"
              allowEditing={false}
              customizeText={this.dateColumn_customizeText}
            />
            <Column
              dataField={'endSubscribedDate'}
              caption={'End Subscribed'}
              dataType="date"
              allowEditing={false}
              customizeText={this.dateColumn_customizeText}
            />
            <Column dataField={'isSubscribed'} caption={'Subscribed'} dataType="boolean" allowEditing={false} />
            <Column
              dataField="Status"
              caption={'Card'}
              width={200}
              editCellRender={() => this.statusEditorRender(options)}
              visible={false}
            />
          </DataGrid>
        </React.Fragment>
      </div>
    );
  }
}

export class Children extends React.Component {
  render() {
    return (
      <Elements stripe={stripePromise}>
        <ElementsConsumer>
          {({ elements, stripe }) => <ChildrenElements elements={elements} stripe={stripe} {...this.props} />}
        </ElementsConsumer>
      </Elements>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Pages/Children.js